export const OPTION_OBJ = {
  name: null,
  score: null,
  valueCode: null,
  sortOrder: 100,
  showOthers: false,
  othersMandatory: false,
  showRemarks: false,
  remarksMandatory: false,
  helpText: null,
};

export const ACTIONS_ARR_OBJ = {
  formOption: { id: null },
  formField: null,
  types: [],
  emailIds: [],
  emailMessage: null,
  notification: '',
  task: '',
};

export const SAVE_STATUS = {
  IDLE: 'idle',
  SAVING: 'saving',
  SAVED: 'saved',
  UNSAVED: 'unsaved',
  ERROR: 'error',
};
